/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Button, TextField, Typography, Link,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router';
import Assistance from './Assistance';
import ForgotPasswordForm from './ForgotPassword';

export const renderTextField = ({
  label,
  input,
  type,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
    variant="outlined"
    margin="normal"
    fullWidth
    type={type}
  />
);

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: '80%',
    marginLeft: '10%',
  },
  ssubmit: {
    margin: theme.spacing(0.5, 0, 0.5),
    width: '80%',
    marginLeft: '10%',
  },
  linkText: {
    color: '#1E88E5',
    textDecoration: 'underline',
    fontSize: '14px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    textAlign: 'center',
    marginTop: '10px',
  },
}));

const LogInForm = (props) => {
  const {
    handleSubmit, loading, accountType,
    impersonate, userEmail, adminEmail,
    initialize, // de redux-form
  } = props;
  const classes = useStyles();
  const [redirect, setRedirect] = useState(false);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);

  useEffect(() => {
    if (impersonate) {
      initialize({
        userEmail,
        adminEmail,
        password: '',
      });
    }
  }, [impersonate, userEmail, adminEmail, initialize]);

  const toPlacementTest = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect push to="/signup" />;
  }

  const handleForgotPasswordClick = () => {
    setForgotPasswordVisible(true);
  };

  const handleBackToLogin = () => {
    setForgotPasswordVisible(false);
  };

  return (
    <div>
      {forgotPasswordVisible ? (
        <ForgotPasswordForm onBack={handleBackToLogin} />
      ) : (
        <form className={classes.form} onSubmit={handleSubmit((values) => props.onSubmit({ ...values, accountType }))}>
          {impersonate ? (
            <>
              <Field
                name="userEmail"
                type="email"
                component={renderTextField}
                label="Email utilisateur"
                InputProps={{ readOnly: true }}
              />
              <Field
                name="adminEmail"
                component={renderTextField}
                label="Adresse email administrateur"
                type="email"
                defaultValue={adminEmail}
              />
              <Field
                name="password"
                type="password"
                component={renderTextField}
                label="Mot de passe administrateur"
              />
            </>
          ) : (
            <>
              <Field
                name="email"
                type="email"
                component={renderTextField}
                label="Adresse email"
              />
              <Field
                name="password"
                type="password"
                component={renderTextField}
                label="Mot de passe"
              />
            </>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            className={classes.submit}
            fullWidth
          >
            {loading ? 'Chargement...' : 'Se connecter'}
          </Button>

          {!impersonate && accountType === 'student' && (
            <>
              <Button
                onClick={toPlacementTest}
                variant="contained"
                disabled={loading}
                color="secondary"
                className={classes.ssubmit}
                fullWidth
              >
                S'inscrire
              </Button>
              <Typography
                onClick={handleForgotPasswordClick}
                className={classes.linkText}
              >
                Mot de passe oublié ?
              </Typography>
            </>
          )}

          <Assistance />

          <Typography
            variant="caption"
            style={{
              width: '100%', color: '#555555', textAlign: 'center', marginRight: '10%',
            }}
          >
            <code>
              v
              {process.env.REACT_APP_VERSION}
            </code>
            <br />
            Copyright ©
            <Link color="inherit" href="https://englishworld.fr/">
              English World
            </Link>
            {' '}
            {new Date().getFullYear()}
            .
          </Typography>
        </form>
      )}
    </div>
  );
};

export default reduxForm({
  form: 'log_in_form',
})(LogInForm);
